import {type JobDetails} from '../../JobDetail/utilTypes';

export enum EntryPoint {
  PROJECT = 'PROJECT',
  // Potential future change: differentiate collections on artifacts vs registries
  PORTFOLIO = 'PORTFOLIO',
  REGISTRY = 'REGISTRY',
  // Org- and team-wide scopes, only selectable in the Automations Hub. Both map
  // to the backend ENTITY scope type (org entity vs team entity).
  ORGANIZATION = 'ORGANIZATION',
  TEAM = 'TEAM',
  // old style model registries
  TEAM_MODEL_REGISTRY = 'TEAM_MODEL_REGISTRY',
  WORKSPACE_PANEL = 'WORKSPACE_PANEL',
  // Org-wide Automations Hub: scope is picked inside the drawer's Step 1
  // via an "Edit scope" sub-view. Once the user picks a scope, the rest of
  // the flow behaves the same as PROJECT/REGISTRY/PORTFOLIO depending on
  // the chosen scope type.
  AUTOMATIONS_HUB = 'AUTOMATIONS_HUB',
}

// Returns true when the automation's scope is set outside the event
// configuration step, so the event fields must not change it. This covers the
// Automations Hub, where the user picks scope with "Edit scope", and editing an
// org- or team-scoped automation, which already has a fixed entity scope.
// Otherwise the artifact event fields (new alias, new tag, link) would
// re-derive scope from the current project or collection and overwrite it.
export function isScopeFixedEntryPoint(
  entryPoint: EntryPoint | undefined
): boolean {
  return (
    entryPoint === EntryPoint.AUTOMATIONS_HUB ||
    entryPoint === EntryPoint.ORGANIZATION ||
    entryPoint === EntryPoint.TEAM
  );
}

export interface JobOption {
  value: JobDetails;
  label: string;
}

export type TriggerFeatureFlags = {
  ariaTriggerEnabled?: boolean;
  sandboxStateEnabled?: boolean;
};
